import { render, staticRenderFns } from "./goods-tag-one.vue?vue&type=template&id=8533ae26&scoped=true&"
import script from "./goods-tag-one.vue?vue&type=script&lang=js&"
export * from "./goods-tag-one.vue?vue&type=script&lang=js&"
import style0 from "./goods-tag-one.vue?vue&type=style&index=0&id=8533ae26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8533ae26",
  null
  
)

export default component.exports